export const PLANNER_CLEAR_CANVAS_EVENT = 'planner-clear-canvas'

/** Ask the live WebGL canvas to wipe the last frame (old kitchen, leftover 2D). */
export function requestPlannerCanvasClear() {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new Event(PLANNER_CLEAR_CANVAS_EVENT))
}
